import { useEffect, useState } from 'react'
import { Icon } from '@/icons/Icon'
import { usePageContext } from '@/components/content/common/PageContext'
import { cn } from '@/lib/utils'

type BreadcrumbProps = {
  placeholder: string
  breakpoint?: string
  title?: string
  hideSlash?: boolean
}

export default function Breadcrumb({ placeholder, breakpoint, title, hideSlash }: BreadcrumbProps) {
  const { activeLabel, setSidebarVisible } = usePageContext()
  const [hasHydrated, setHasHydrated] = useState(false)

  useEffect(() => {
    setHasHydrated(true)
  }, [])

  const label = hasHydrated && activeLabel ? activeLabel : placeholder

  return (
    <button
      onClick={() => setSidebarVisible(true)}
      className="flex h-14 flex-1 items-center gap-3.5 truncate md:hidden"
    >
      {title && (
        <span className="hidden font-semibold text-gray-950 dark:text-white xs:inline">
          {title}
        </span>
      )}
      {!hideSlash && (
        <span
          className={cn(
            'hidden text-13 text-gray-400',
            breakpoint === 'md' ? 'md:block' : 'xs:block',
          )}
        >
          /
        </span>
      )}
      <Icon name="menu-left" className="text-gray-500" size={12} />
      <span className="w-fit justify-start truncate text-14 font-medium text-gray-950 dark:text-white">
        {label}
      </span>
      <Icon name="chevron-left" className="-rotate-90 text-gray-500" size={12} />
    </button>
  )
}
